import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FnUtilService, FnToasterService } from 'foundation';
import { EOStatusType, EOTeam } from '../../../modal/entity.modal';
import { PosHttpService } from '../../../services/pos.http.service';
import { EOCommentDetail } from '../../../modal/entity.modal';

@Component({
  selector: 'app-dashboard-change-severity-model',
  templateUrl: './dashboard-change-severity-model.component.html',
  styleUrl: './dashboard-change-severity-model.component.scss'
})
export class DashboardChangeSeverityModelComponent {
  severity: any;
  commentObject: { textComment: string } = { textComment: '' };
  sevArray: any[] = [];
  isSendTelegram: boolean = false;
  isSelected: boolean = false;
  commentArr: EOCommentDetail[] = [];
  
  constructor(@Inject(MAT_DIALOG_DATA) public dialogData: HwDialogData, private posHttpSvcs: PosHttpService, private dialogRef: MatDialogRef<DashboardChangeSeverityModelComponent>, private fnutilservice: FnUtilService, private toaster: FnToasterService) { 
    const allSeverities = [
      { name: 'Sev 1' },
      { name: 'Sev 2' },
      { name: 'Sev 3' }
    ];
    this.severity = this.dialogData.severity.severity; 
    this.sevArray = allSeverities.filter(sev => sev.name !== this.severity);
  }

  loadComments(): void {
    this.posHttpSvcs.authPost('v1/ui/getEOCommentArray', 'getEOCommentArray', this.dialogData.severity.primaryKey).subscribe((resp: { isError: string; data: EOCommentDetail[]; }) => {
      if (resp.isError) {
        this.toaster.error("EOCommentArray is not loaded");
      }
      this.commentArr = resp.data;
      this.sendtoTelegram();
    }
    );
  }

  sendtoTelegram(): void {
    let msg = `Action: Changed Severity\n`;

    const filteredComments = this.commentArr.map(comment => {
      return comment;
    });
    if (filteredComments.length === 0) {
      const latestComment = filteredComments[filteredComments.length - 1];
      msg += `Action By : ${latestComment.commentedBy}\n`;
      msg += `Action At : ${latestComment.commentedAt}\n`;
      msg += `Comment : ${latestComment.commentText}\n`;
      msg += `New Severity : ${this.severity}\n`;
    } else if (filteredComments.length >= 1) {
      const lastComment = filteredComments[filteredComments.length - 1];
      const latestComment = filteredComments[filteredComments.length - 2];  
      msg += `Action By : ${lastComment.commentedBy}\n`;
      msg += `Action At : ${lastComment.commentedAt}\n`;
      msg += `Comment: ${lastComment.commentText}\n`;
      msg += `New Severity : ${this.severity}\n\n`;
      msg += `Last Action By : ${latestComment.commentedBy}\n`;
      msg += `Last Action At : ${latestComment.commentedAt}\n`;
      msg += `Last Comment : ${latestComment.commentText}\n`;
    }
    const pktData = {
      msg: msg,
      pk: this.dialogData.severity.primaryKey
    };
    this.posHttpSvcs.authPost('v1/ui/generateTelegram', 'generateTelegram', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error("Telegram Msg not sent");
        return;
      }
    }));
  }

  close() {
    this.dialogRef.close();
  }

  Update() {
    if (this.fnutilservice.isEmptyObject(this.severity)) {
      this.toaster.error('Please select severity');
      throw new Error();
    }
    if (this.fnutilservice.isEmptyObject(this.commentObject.textComment)) {
      this.toaster.error('Please add comment');
      return
    }
    const pktData = {
      commentText: this.commentObject.textComment,
      isSendTelegram: this.isSendTelegram,
      severity: this.severity,
      pk: this.dialogData.severity.primaryKey
    };
    this.posHttpSvcs.authPost('v1/ui/changeSeverity', 'changeSeverity', pktData).subscribe((resp => {
      if (resp.isError) {
        this.toaster.error(resp.data);
        return;
      } else {
        this.toaster.success(resp.data);
        if (this.isSendTelegram){
          this.loadComments();
        }
        this.commentObject.textComment = '';
      }
      this.dialogRef.close(resp.isError);
    }));
    
  }

  selectionCheck(event: any): void {
    this.isSelected = event.target.checked;
    }
}

interface HwDialogData {
  severity: any;
}
